// Odoo Partner section
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import odooLogo from "../../../../assets/images/odoo-Logo.png";

function OdooPartner() {
  return (
    <MKBox component="section" py={6} sx={{ backgroundColor: "#f8fafc" }}>
      <Container>
        <Grid container alignItems="center" spacing={3}>
          <Grid item xs={12} md={4} sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Box component="img"
              src={odooLogo}
              alt="Odoo logo"
              sx={{ height: 64, mb: { xs: 2, md: 0 } }}
            />
          </Grid>

          <Grid item xs={12} md={8}>
            <MKTypography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
              Official Odoo Partner
            </MKTypography>
            <MKTypography variant="body1" color="text">
              We design, implement and support Odoo ERP solutions tailored to
              your business. From implementation to customization and
              long-term support — we help companies get the most from Odoo.
            </MKTypography>

          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default OdooPartner;
